import React from "react";
import { Polyline, CircleMarker, Popup } from "react-leaflet";
import { useTranslation } from "react-i18next";

import { StoreContext } from "../../store/StoreContext";

export const Trip = ({ trip }) => {
  const { precision } = React.useContext(StoreContext);
  const {t} = useTranslation();
  if (!trip) return null;
  const positions = trip.records.map((record) => [
    record.latitude / precision,
    record.longitude / precision,
  ]);

  return (
    <>
      {trip.records
        .filter((record, i) => i % 5 == 0)
        .map((record) => (
          <CircleMarker
            key={record.id.toString()}
            center={[record.latitude / precision, record.longitude / precision]}
            radius={15}
          >
            <Popup>
              {t("SPEED")}: {record.speed} <br />
              Satellites: {record.satellites}
            </Popup>
          </CircleMarker>
        ))}
      <Polyline positions={positions} pathOptions={{ color: "yellow" }} />
    </>
  );
};
